export class CurrencyDTO {
  name: string;
  symbol: string;
  code: string;
}
